/**
 * Platform-level kill-switch for Zebra / QZ Tray printing.
 * Company policy is layered on top via `useZebraPrintEnabled`.
 */
export function isZebraEnvEnabled(): boolean {
  const raw = import.meta.env.VITE_ZEBRA_PRINT_ENABLED;
  if (raw === undefined || raw === null) return false;
  const v = String(raw).trim().toLowerCase();
  return v === "true" || v === "1";
}

/**
 * Combined check when the caller already has the company setting in hand
 * (used outside React contexts and in tests).
 */
export function isZebraPrintEnabled(companyEnabled: boolean): boolean {
  return isZebraEnvEnabled() && companyEnabled;
}
